'use client';

import type { UnknownVisualBlock } from '@jeraisonne/ai/visual-blocks';

export function UnknownVisualBlockRenderer({ block }: { block: UnknownVisualBlock }) {
  if (block.src) {
    return (
      <img
        src={block.src}
        alt={block.caption ?? block.title ?? 'Élément visuel'}
        className="max-w-full rounded-lg"
        loading="lazy"
      />
    );
  }

  return (
    <div className="border-ink-200 bg-ink-50 flex min-h-[80px] items-center justify-center rounded-xl border-2 border-dashed px-4 py-6">
      <p className="text-ink-400 text-center text-sm">
        {block.reason ?? 'Élément visuel non reconstruit'}
        {block.detectedKind && <span className="text-ink-300 ml-1">({block.detectedKind})</span>}
      </p>
    </div>
  );
}
